var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'sj-label',
    ("label-" + _vm.type),
    ("label-theme-" + _vm.theme),
    ("label-size-" + _vm.size),
    { active: _vm.value, disabled: _vm.disabled }
  ],on:{"click":_vm.handleClick}},[_vm._t("default"),(_vm.removable)?_c('span',{staticClass:"sj-label-remove-icon",on:{"click":function($event){return _vm.$emit('remove')}}},[_c('i',{staticClass:"icon_com commulti_close"})]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }